import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQuery } from "@/api/queries/session";
import { isSafeReturnTo } from "@/domain/identity";

export interface JoinSearch {
  /** Where to go after signing in. Only same-origin relative paths survive validation. */
  returnTo?: string;
  /** "signin" switches the copy for returning people; the flow is the same. */
  mode?: "signin";
}

// Pass-through parent for /join (email) and /join/email (code), sharing their search params.
export const Route = createFileRoute("/_onboarding/join")({
  validateSearch: (search: Record<string, unknown>): JoinSearch => ({
    returnTo: typeof search.returnTo === "string" && isSafeReturnTo(search.returnTo) ? search.returnTo : undefined,
    mode: search.mode === "signin" ? "signin" : undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery());
    if (session.status !== "authenticated") return;
    if (!session.person) throw redirect({ to: "/welcome", search: { step: "identity", returnTo: search.returnTo } });
    throw redirect({ href: search.returnTo ?? "/feed" });
  },
  component: () => <Outlet />,
});
